<template>
  <div class="all-make-your-marks">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="All Innovation Always On"></ContentHeader>
        <div class="alert alert-info">
          <h4 class="alert-heading">Filtered Search</h4>
          <hr>
          <div class="row">
            <div class="col-xl-6 mb-2">
              <label>Category</label>
              <select v-model="ideaCategorySelect" v-on:change="loadIdeas()" class="form-control">
                <option>-- All --</option>
                <option v-for="category in ideaCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
              </select>
            </div>
            <div class="col-xl-6 mb-2">
              <label>Community</label>
              <select v-model="communityCategorySelect" v-on:change="loadIdeas()" class="form-control">
                <option>-- All --</option>
                <option v-for="category in communityCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <Ideas v-if="ideas.length > 0" :ideas="ideas"></Ideas>
        <span v-if="ideas.length === 0">
          No ideas have been submitted, <router-link to="/idea-challenges">view the Idea Challenges here</router-link> and submit an idea
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalIdeas" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Ideas per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadIdeas()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ContentHeader from '@/components/ContentHeader'
import Ideas from '@/components/Ideas'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Ideas
  },
  data () {
    return {
      ideas: [],
      contentReady: false,
      contentLoadError: '',
      ideaCategories: [],
      ideaCategorySelect: '-- All --',
      communityCategories: [],
      communityCategorySelect: '-- All --',
      currentPage: 1,
      totalIdeas: 0,
      itemsPerPage: 10
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('idea_chalenge_category?per_page=100')
      .then(response => {
        this.ideaCategories = response.data.filter(x => x.parent === 10)
      })
      .catch(e => {
        console.error(e)
      })
    WordpressRestAPI.getViewContent('community_categories?per_page=100')
      .then(response => {
        this.communityCategories = response.data
      })
      .catch(e => {
        console.error(e)
      })
    this.loadIdeas()
  },
  methods: {
    generateSearchQuery: function () {
      if (this.ideaCategorySelect !== '-- All --' && this.communityCategorySelect === '-- All --') {
        return '?idea_chalenge_category=' + this.ideaCategorySelect + '&_embed'
      } else if (this.ideaCategorySelect === '-- All --' && this.communityCategorySelect !== '-- All --') {
        return '?idea_chalenge_category=10&community_categories=' + this.communityCategorySelect + '&_embed'
      } else if (this.ideaCategorySelect !== '-- All --' && this.communityCategorySelect !== '-- All --') {
        return '?idea_chalenge_category=10,' + this.ideaCategorySelect + '&community_categories=' + this.communityCategorySelect + '&_embed'
      } else {
        return '?_embed&idea_chalenge_category=10'
      }
    },
    loadIdeas: function () {
      this.contentReady = false
      WordpressRestAPI.getViewContent('idea' + this.generateSearchQuery() + '&page=' + this.currentPage + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalIdeas = parseInt(response.headers['x-wp-total'])
          this.ideas = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem loading ideas. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      this.loadIdeas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/AllMakeYourMarks.vue